import { axiosDS } from '@pp/axios'
import { urls } from 'Src/constants/Urls'
import { RequestParams, ResponseCatalog } from 'Models'
import { ActUnpaidCounterModel, ActUnpaidModel, ActsUnpaidFitersType } from 'Pages/acts'

async function getUnpaidActsCounter(params?: RequestParams) {
	const res = await axiosDS().get<ActUnpaidCounterModel>(urls.acts.act_counter, { params })
	return res.data
}

async function getUnpaidActsFilteredBy(filterName: ActsUnpaidFitersType, params?: RequestParams) {
	const res = await axiosDS().get<ResponseCatalog<ActUnpaidModel>>(
		urls.acts.act_counter_filter.replace(':filter', filterName),
		{
			params,
		}
	)
	return res.data
}

export const actUnpaidApi = {
	getUnpaidActsCounter,
	getUnpaidActsFilteredBy,
}
